export default "__VITE_ASSET__C8Iz3Pab__"